import { pWarn } from '_/helpers/logger';

import { eventBus } from '_/helpers/eventBus';

import { mapGetters } from 'vuex';

export default {
    /**
     * Define props
     *
     * @type  {Object}
     */
    props: {
        defaultValue: {
            type: [Boolean, String],
        },
        disabled: {
            type: Boolean,
        },
        id: {
            required: true,
            type: [Number, String],
        },
        name: {
            required: true,
            type: String,
        },
        placeholder: {
            type: String,
        },
        refreshFields: {
            type: Number,
        },
        type: {
            default: 'text',
            type: String,
        },
        value: {
            default: null,
            type: [String, Boolean, Number],
        },
        focus: {
            default: false,
            type: [Boolean],
        },
    },

    /**
     * Set the computed properties
     *
     * @type {object}
     */
    computed: {
        ...mapGetters({
            ui: 'ui/ui',
        }),

        spellcheck() {
            return this.ui.photonConfig.spellcheck;
        },
    },

    /**
     * Set the methods
     *
     * @type  {Object}
     */
    methods: {
        /**
         * Creates the event payload
         *
         * @param   {object}  event
         * @return  {object}
         */
        createEventPayload(event) {
            return {
                event,
                id: event.target.id,
                name: event.target.name,
                value: event.target.value,
            };
        },

        /**
         * Emmits a change event with a payload consting of input value and the event object
         *
         * @param   {event}  event
         * @return  {void}
         */
        onChange: function (event) {
            this.$emit('change', this.createEventPayload(event));

            eventBus.$emit('fieldTypeChange', this.createEventPayload(event));
        },

        /**
         * Emmits a global change event with a payload consting of input value and the event object
         *
         * @param   {event}  event
         * @return  {void}
         */
        onBlur: function (event) {
            eventBus.$emit('fieldTypeBlur', this.createEventPayload(event));
        },

        /**
         * Sets a component value to defaultValue, if required
         *
         * @return  {void}
         */
        setDefaultValueIfRequired() {
            if (this.value === null && this.defaultValue) {
                this.$emit('change', {
                    id: this.id,
                    name: this.name,
                    value: this.defaultValue,
                });
            }
        },
    },

    /**
     * Set the mounted hook
     *
     * @return  {void}
     */
    mounted() {
        this.$nextTick(() => {
            this.setDefaultValueIfRequired();

            if (this.focus) {
                $(this.$el).find(`#${this.id}`).focus();
            }
        });
    },

    watch: {
        refreshFields(newEntry, oldEntry) {
            if (newEntry !== oldEntry) {
                pWarn('Watched property fired.', `InputTag.${this.name}`, 'refreshFields', newEntry, oldEntry, this);

                this.setDefaultValueIfRequired();

                this.$forceUpdate();

                $(this.$el).val(this.value);

                if (this.focus) {
                    $(this.$el).find(`#${this.id}`).focus();
                }
            }
        },
    },
};
